import classNames from "classnames";
import { useRecoilValue } from "recoil";

import { FilterColors } from "@/components/filter/FilterColors";
import { FilterDiscounts } from "@/components/filter/FilterDiscounts";
import { FilterHeader } from "@/components/filter/FilterHeader";
import { FilterSizes } from "@/components/filter/FilterSizes";
import { FilterStores } from "@/components/filter/FilterStores";
import { secondFilterSelectedState } from "@/components/filter/secondFilterSelectedState";
import { storesSelectState } from "@/components/filter/storesSelectState";
import { useFilterHandlers } from "@/components/filter/useFilterHandlers";
import { IconButton } from "@/components/ui-components/IconButton";
import useFilterQuery from "@/hooks/useFilterQuery";
import { useLockBodyScrollModified } from "@/hooks/useLockBodyScrollModified";
import { useModalAppearing } from "@/hooks/useModalAppearing";

import { ModalPortal } from "../ModalPortal";
import styles from "./SecondaryFilterModal.module.scss";

interface SecondFilterModalProps {
  isOpen: boolean;
  close(): void;
}

const SecondaryFilterModal = ({ isOpen, close }: SecondFilterModalProps) => {
  const secondFilterSelect = useRecoilValue(secondFilterSelectedState);
  const selectedStores = useRecoilValue(storesSelectState);

  const { isVisible, mounting, hiding } = useModalAppearing({ isOpen });
  useLockBodyScrollModified(isOpen);

  const { applySecondFilters, applyStores, resetToAppliedSecondFilter } =
    useFilterHandlers();

  const { count } = useFilterQuery();

  const applySecondFiltersHandler = () => {
    applySecondFilters(
      secondFilterSelect.sizes,
      secondFilterSelect.colors,
      secondFilterSelect.discounts
    );
    applyStores(selectedStores);
    close();
  };

  const closeWithoutSaving = () => {
    resetToAppliedSecondFilter();
    close();
  };

  if (!isVisible) return null;

  return (
    <ModalPortal>
      <div
        className={classNames(styles.root, {
          [styles.show]: mounting,
          [styles.hide]: hiding,
        })}
      >
        <FilterHeader
          leftSlot={<div />}
          rightSlot={
            <IconButton
              onClick={closeWithoutSaving}
              src="/static/img/icons-v6/cross.svg"
              alt="close button"
              className={styles.closeBtn}
            />
          }
        />
        <div className={classNames(styles.tabContainer)}>
          <FilterStores />
          <FilterColors />
          <FilterSizes />
          <FilterDiscounts />
        </div>
        <button onClick={applySecondFiltersHandler} className={styles.applyBtn}>
          Показать{Boolean(count) && ` (${count})`}
        </button>
      </div>
    </ModalPortal>
  );
};

export default SecondaryFilterModal;
